import type { User } from '@supabase/supabase-js';

export const requiresPasswordSetup = (user: User | null | undefined): boolean =>
  Boolean(user?.user_metadata?.requires_password_setup);
